import {
	useState,
	useEffect,
	useRef
} from "react";
import {
	Navigate,
	useParams,
	useNavigate
} from "react-router-dom";
import {
	Box,
	Typography,
	Grid,
} from '@mui/material';
import jss from '../../components/client/profile/ProfileCommonJss'
import TipsContext from "../../providers/GlobalTip";
import CurrentClientContext from "../../providers/CurrentClientProvider";
import ClientService from "../../services/ClientService";
import ClientProfileLocationList from "../../components/client/profile/ClientProfileLocationList";
import ClientProfileClassList from "../../components/client/profile/ClientProfileClassList";
import ClientLocationEdit from "../../components/client/profile/ClientLocationEdit";
import ClientLocationClassLinkEdit from "../../components/client/profile/ClientLocationClassLinkEdit";
import ClassBulkEdit from "../../components/client/profile/ClassBulkEdit";
import ClientCategoryClassList from "../../components/client/category/ClientCategoryClassList";
import ClientCategoryList from "../../components/client/category/ClientCategoryList";
import ClientClassEdit from "../../components/client/profile/ClientClassEdit";
import ClientCategoryEdit from "../../components/client/category/ClientCategoryEdit";
import LabelService from "../../services/LabelService";

function ClientCategories(props) {
	const [categories, setCategories] = useState()
	const [classes, setClasses] = useState()
	const [currentClasses, setCurrentClasses] = useState([])
	const [allClasses, setAllClasses] = useState([])
	const [currentCategory, setCurrentCategory] = useState(null)
	// const [locations, setLocations] = useState()
	const currentClientContext = CurrentClientContext.useClient()
	// const [labelData, setLabelData] = useState()
	// const [masterCategories, setMasterCategories] = useState([])

	useEffect(() => {
		if( currentClientContext.client ) {
			getClientCategories()
			getClientClasses()
		}
	}, [currentClientContext.client])

	async function getClientClasses() {
		const data = await ClientService.getClientClasses(currentClientContext.client.Id);
		setAllClasses(data)
	}

	async function getClientCategories(setCurrent = true) {
		const result = await ClientService.getClientCategories(currentClientContext.client.Id, ['classes'])
		let _c = []
		let _categories = []
		if (result[0]) {
			result[0].classes.map(item => {
				_c.push(item)
			})

			_categories = result.sort((a, b) => {
				return parseInt(a.SortOrder) - parseInt(b.SortOrder)
			})

			if (setCurrent) {
				setCurrentCategory(result[0])
			}
		}
		setCategories(_categories)
		setClasses(_c)
	}

	function categoryChange(items) {
		setClasses(items.classes)
		setCurrentCategory(items)
	}

	function classChoose(items) {
		setCurrentClasses(items)
	}

	function deleteCategory(categoryId) {
		let _categories = categories.filter((item) => {
			return item.Id != categoryId
		})
		setCategories(_categories)
	}

	function updateCategory(item) {
		let _categories = categories.map(i => {
			if (i.Id == item.Id) {
				return item;
			} else {
				return i;
			}
		}).sort((a, b) => a.SortOrder - b.SortOrder)

		setCategories(_categories)

	}

	function handleSingleClassUpdate(e) {
		console.log(e)
	}

	function createCategory(item) {
		let _c = categories.map(_cat => _cat);
		_c.push(item)

		if (!categories) {
			setCurrentCategory(item)
		}

		setCategories(_c)
	}

	return <Box sx={{py:2}}>
		<Grid container spacing={2}>
			<Grid item xs={12} sm={7}>
				<Box sx={jss.title}>CATEGORIES</Box>
				<Box sx={jss.dataGrid}>
					<ClientCategoryList
						categories={categories}
						onCategoryChange={categoryChange}
						createCategory={createCategory}
						currentCategory={currentCategory}
						clientId={currentClientContext?.client?.Id}
					/>
					<ClientCategoryClassList
						classes={classes}
						onClassChange={classChoose}
						allClasses={allClasses}
						currentCategory={currentCategory}
						updateCategories={getClientCategories}
					/>
				</Box>
			</Grid>
			<Grid item xs={12} sm={5}>
				<Box sx={jss.title}> </Box>
					{ currentCategory &&
						<ClientCategoryEdit category={currentCategory} updateCategory={updateCategory} deletedCategory={deleteCategory} />
					}
			</Grid>
		</Grid>
	</Box>
}

export default ClientCategories